export default [
  {
    path: '/lecturerCenter',
    name: 'lecturerCenter',
    component: () => import('@/views/lecturer/Center.vue'),
    meta: { title: '讲师中心', customWechatShare: true }
  }, {
    path: '/lecturerSearch',
    name: 'lecturerSearch',
    component: () => import('@/views/lecturer/Search.vue'),
    meta: { title: '讲师中心', customWechatShare: true }
  },
  {
    path: '/lecturerDetail',
    name: 'lecturerDetail',
    component: () => import('@/views/lecturer/lecturerDetail.vue'),
    meta: { title: '讲师详情', customWechatShare: true, isKeepAlive: true }
  }
]
